// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Trigger_trigger__43iUU","label":"Trigger_label__agAHx","labelString":"Trigger_labelString__8vsYD"};